import { MessagesSquare, Sprout, ClipboardCheck, FileCheck2, Ship, HeartHandshake } from 'lucide-react';
import Reveal from './Reveal';

const POINTS = [
  { icon: MessagesSquare, title: 'Transparent Communication', text: 'Clear, prompt and honest at every step.' },
  { icon: Sprout, title: 'Quality-Focused Sourcing', text: 'Products selected with care from reliable origins.' },
  { icon: ClipboardCheck, title: 'Buyer-Specific Requirements', text: 'Your specification leads the conversation.' },
  { icon: FileCheck2, title: 'Clear Documentation', text: 'Paperwork prepared properly, every time.' },
  { icon: Ship, title: 'Reliable Coordination', text: 'Organized follow-through from enquiry to dispatch.' },
  { icon: HeartHandshake, title: 'Long-Term Relationships', text: 'Built for partnerships, not one-off deals.' },
];

export const Trust = () => (
  <section id="why" data-testid="trust-section" className="relative overflow-hidden bg-forest py-24 sm:py-32">
    <div className="pointer-events-none absolute -top-32 right-0 h-96 w-96 rounded-full bg-sage/10 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-40 -left-20 h-96 w-96 rounded-full bg-gold/10 blur-3xl" />

    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-gold-soft">Why SKycodeX AgroTech</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-5 max-w-4xl font-display text-4xl font-medium leading-[1.1] tracking-tight text-cream sm:text-5xl lg:text-6xl">
          Trust is <span className="accent-italic font-semibold">our business.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.18}>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-cream/70">
          We are building SKycodeX AgroTech the way trade should work — quality first, communication open, and
          commitments kept. No exaggeration, no noise. Just dependable agricultural export from India.
        </p>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-3xl border border-cream/15 bg-cream/10 sm:grid-cols-2 lg:grid-cols-3">
        {POINTS.map((point, i) => (
          <Reveal key={point.title} delay={i * 0.08} className="h-full">
            <div
              data-testid={`trust-point-${i}`}
              className="group flex h-full flex-col bg-forest p-8 transition-colors duration-500 hover:bg-forest-deep"
            >
              <point.icon className="h-6 w-6 text-gold-soft transition-transform duration-500 group-hover:-translate-y-1" />
              <h3 className="mt-5 font-display text-lg font-semibold text-cream">{point.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-cream/60">{point.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Trust;
